const STORAGE_KEY = 'mamv_app_accounts';

/**
 * Gespeicherte Companion-Konten auf diesem Gerät (ohne Passwörter).
 * @typedef {{ id: string, email?: string|null, full_name?: string|null, areas?: string[] }} SavedAppAccount
 */

export function listSavedAppAccounts() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter((a) => a && a.id) : [];
  } catch {
    return [];
  }
}

/** @param {SavedAppAccount} account */
export function rememberAppAccount(account) {
  if (!account?.id) return listSavedAppAccounts();
  const next = {
    id: String(account.id),
    email: account.email || null,
    full_name: account.full_name || null,
    areas: Array.isArray(account.areas) ? account.areas : [],
  };
  const prev = listSavedAppAccounts().filter((a) => a.id !== next.id);
  const all = [next, ...prev].slice(0, 12);
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    /* ignore quota */
  }
  return all;
}

export function removeSavedAppAccount(userId) {
  const all = listSavedAppAccounts().filter((a) => a.id !== String(userId));
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch {
    /* ignore */
  }
  return all;
}

/** Bereiche, die im Profil-Umschalter sichtbar sind (ohne Legacy). */
export function switchableAreas(areas) {
  const order = ['verwaltung', 'lehrer', 'schueler', 'eltern'];
  const set = new Set();
  for (const a of areas || []) {
    if (a === 'personal') set.add('lehrer');
    else if (a === 'privat') set.add('schueler');
    else if (order.includes(a)) set.add(a);
  }
  return order.filter((a) => set.has(a));
}
